module.exports = __webpack_public_path__ + "static/Monoswap-7e008589ce89d9ccbedf3fbb9e6da623.png";